










module.exports =
  name: 'hm_menu'
  computed:
    user: -> @$store.state.user.userdata
  mounted: ->
    $(document).off('keydown.menu_hotkeys').on 'keydown.menu_hotkeys', (event) =>
      return if $('textarea:focus').length > 0
      return if $('input:focus').length > 0
      @$router.push { name: 'accounts_page' }   if event.altKey && event.keyCode == 49 # Alt + 1
      @$router.push { name: 'calendar' }        if event.altKey && event.keyCode == 50 # Alt + 2
      @$router.push { name: 'list' }            if event.altKey && event.keyCode == 51 # Alt + 3
      @$router.push { name: 'compare_periods' } if event.altKey && event.keyCode == 52 # Alt + 4
